import styled from 'styled-components'

export const RocketImage = styled.img`
  transform: scaleX(-1);
`
